module.exports = __webpack_public_path__ + "static/media/nesterra.d687e690.png";


//////////////////
// WEBPACK FOOTER
// ./src/nesterra.png
// module id = 233
// module chunks = 0